"use client";

import { useMemo } from "react";

import React, { useRef, useEffect, useState } from "react";
import UserInput from "./components/UserInput";
import UserPlan from "./components/UserPlan";

import { CopilotSidebar } from "@copilotkit/react-ui";
import "@copilotkit/react-ui/styles.css";
import { CopilotKit, useCoAgent, useCoAgentStateRender } from "@copilotkit/react-core";
// import { useCoAgent, useCoAgentStateRender } from '@copilotkit/react-core';
import { useLangGraphInterrupt } from "@copilotkit/react-core"; 

import { AgentState } from "@/lib/types";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { Menu } from "lucide-react";

import { CaseStudySection } from "../landing/sections/case-study-section";
import { SiteHeader } from "../chat/components/site-header";

import { HeaderProps, useChatContext } from "@copilotkit/react-ui";
import { BookOpenIcon } from "@heroicons/react/24/outline";
import "@copilotkit/react-ui/styles.css";

function Header({}: HeaderProps) {
  const { setOpen, icons, labels } = useChatContext();
 
  return (
    <div className="flex justify-between items-center p-4 bg-black text-white">
      <div className="w-24">
        <a href="/">
          <BookOpenIcon className="w-6 h-6" />
        </a>
      </div>
      <div className="text-lg">{labels.title}</div>
      <div className="w-24 flex justify-end">
        <button onClick={() => setOpen(false)} aria-label="Close">
          {icons.headerCloseIcon}
        </button>
      </div>
    </div>
  );
};

export default function Home() {
  // 检查 URL 是否包含 replay=state_rnaseq.json
  const [replayMsg, setReplayMsg] = useState<string | null>(null);
  useEffect(() => {
    if (typeof window !== "undefined") {
      const params = new URLSearchParams(window.location.search);
      const replay = params.get("replay");
      if (replay === "state_rnaseq.json") {
        setReplayMsg("已检测到跳转参数：replay=state_rnaseq.json，正在恢复会话状态...");
      }
    }
  }, []);

  return (
    <div className="flex flex-col items-center min-h-screen bg-black">
      <SiteHeader />
      <main className="container flex flex-col items-center justify-center gap-0">
        <UserInput />
        <UserPlan />
      </main>
      <Footer />
    </div>
  );
}


function Footer() {
  const year = useMemo(() => new Date().getFullYear(), []);
  return (
    <footer className="container mt-32 flex flex-col items-center justify-center">
      <hr className="from-border/0 via-border/70 to-border/0 m-0 h-px w-full border-none bg-gradient-to-r" />
      <div className="text-muted-foreground container flex h-20 flex-col items-center justify-center text-sm">
        <p className="text-center font-serif text-lg md:text-xl">
          &quot;Originated from Open Source, give back to Open Source.&quot;
        </p>
      </div>
      <div className="text-muted-foreground container mb-8 flex flex-col items-center justify-center text-xs">
        <p>Licensed under MIT License</p>
        <p>&copy; {year} BioAgent</p>
      </div>
    </footer>
  );
}